import { ScanView } from '@/components/ScanView';
import { useAuthStore } from '@/stores/auth-store';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { toast } from 'sonner';

export const Route = createFileRoute('/_app/staff/scan/lunch')({
  beforeLoad: () => {
    const { user } = useAuthStore.getState();
    if (
      !user ||
      (user.role !== 'ORGANIZER' && user.role !== 'STAFF_LUNCH' && user.role !== 'STAFF_SCANNER')
    ) {
      toast.info('Acceso restringido a staff de almuerzo.');
      throw redirect({ to: '/' });
    }
  },
  component: LunchScanPage,
});

function LunchScanPage() {
  return <ScanView type="LUNCH" title="Escanear almuerzo" />;
}
